import React, { useEffect, useState } from "react";
import { Button, CardSchemeIcon, FlexContainer, LabelText, Text } from "../../../../design";

type Props = {
  paymentMethod: Object,
  history: Object,
  account: Object,
}

const PaymentMethodList = (props: Props) => {
  const { account } = props;
  const alpha2 = (account && account.country && account.country.alpha2);

  const [paymentMethod, setPaymentMethod] = useState(props.paymentMethod || null);

  useEffect(() => {
    setPaymentMethod(props.paymentMethod);
  }, [props.paymentMethod]);

  const redirect = url => {
    if (props.history) {
      props.history.push(url);
    }
  };

  return (
    <>
      {
        (alpha2 !== 'IN') && (
          <>
            <div className="px-4">
              <LabelText marginTop="30px" marginBottom="10px"> Payment Method </LabelText>
            </div>
            <hr className="my-2" />
            <FlexContainer paddingLeft="1.5rem" >
              <div style={{ display: "block" }}>
                <table style={{ marginTop: "-10px" }}>
                  <tbody>
                    {
                      paymentMethod ? (
                        <tr>
                          <th>
                            <CardSchemeIcon
                              style={{ paddingRight: "15px", borderRadius: "3px", width: "2.8rem", verticalAlign: 'middle' }}
                              scheme={(paymentMethod && paymentMethod.card) ? (paymentMethod.card && paymentMethod.card.scheme) : (paymentMethod && paymentMethod.bank) ? 'ACH' : ''} className="" />
                          </th>
                          <th>
                            <Text
                              fontSize="14px"
                              marginTop="30px"
                              marginBottom="10px"
                              color="#0d0d0d"
                              fontWeight="600"
                            >
                              ****{(paymentMethod && paymentMethod.card) ? (paymentMethod.card && paymentMethod.card.lastFour) : (paymentMethod && paymentMethod.bank) ? (paymentMethod.bank && paymentMethod.bank.lastFour) : ''}
                            </Text>
                            {
                              paymentMethod && paymentMethod.card && (<Text
                                fontSize="13px"
                                marginBottom="10px"
                                color="#6b6c6f"
                              >
                                Expires {`${('0' + paymentMethod.card.expiryMonth).slice(-2)}/${paymentMethod.card.expiryYear}`}
                              </Text>)
                            }
                          </th>
                          <th>
                            <Text marginLeft="15px" borderRadius="50px" paddingLeft="20px" fontWeight="600" paddingRight="20px" paddingTop="3px" paddingBottom="3px" fontSize="12px" backgroundColor="#e2dddd">Default</Text>
                          </th>
                        </tr>
                      ) : <tr><th><p className="mt-4 text-muted">No Data</p></th></tr>
                    }
                  </tbody>
                </table>
                <Button type="secondary"
                  borderRadius="50px"
                  border="1px solid #40a9ff !important"
                  className="px-3 py-2 mt-3"
                  onClick={() => redirect(props.history.location.pathname + '/payment-method/add')}
                >{`${paymentMethod ? "Update" : "+ Add"} a Payment Method`}</Button>
              </div>
            </FlexContainer>
          </>
        )
      }
    </>
  )
};

export default PaymentMethodList;
